// extracted by mini-css-extract-plugin
export default {"divider":"Divider-module__divider__ocnrd"};